module.exports = "<ratings-page></ratings-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/ratings.html
// module id = 1628
// module chunks = 0